var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'visible' : _vm.show },attrs:{"id":"loadingOverlay"}},[_c('b-progress',{staticStyle:{"width":"200px"},attrs:{"value":100,"max":100,"animated":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }